module.exports = "<div class=\"container\" [ngClass]=\"{'valid': isValid, 'invalid': !isValid}\">\n  <span *ngIf=\"label\">{{label}}</span>\n  <i *ngIf=\"!label\" [ngClass]=\"{'icon-accept': isValid, 'icon-close': !isValid}\"></i>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/widgets/explorer/components/item-state/item-state.component.html
// module id = ../../../../../src/app/modules/widgets/explorer/components/item-state/item-state.component.html
// module chunks = main